// Bilingual strings + enum labels for the B2B Used-Cars Auction module.
// Components accept a `lang` prop ('en' | 'ar') and read copy via `at(lang, key)`.

const DICT = {
  // Catalog
  backToUsedCars: { en: 'Used Cars & Auction', ar: 'السيارات المستعملة والمزاد' },
  catalogTitle: { en: 'Auction Catalogue', ar: 'كتالوج المزاد' },
  catalogSubtitle: { en: 'Sealed-offer bidding for registered B2B buyers.', ar: 'مزايدة بعروض مغلقة لمشتري الأعمال المسجّلين.' },
  registerToBid: { en: 'Register to bid', ar: 'سجّل للمزايدة' },
  signOut: { en: 'Sign out', ar: 'تسجيل الخروج' },
  searchPlaceholder: { en: 'Search make, model or lot number…', ar: 'ابحث بالماركة أو الموديل أو رقم اللوت…' },
  allSources: { en: 'All sources', ar: 'جميع المصادر' },
  allStatuses: { en: 'All statuses', ar: 'جميع الحالات' },
  loadingLots: { en: 'Loading lots…', ar: 'جارٍ تحميل اللوتات…' },
  lotsAvailable: { en: (n) => `${n} lot${n === 1 ? '' : 's'} available`, ar: (n) => `عدد اللوتات المتاحة: ${n}` },
  noLotsTitle: { en: 'No lots match your filters.', ar: 'لا توجد لوتات مطابقة لعوامل التصفية.' },
  noLotsSub: { en: 'New vehicles are added every week — check back soon or clear your filters.', ar: 'نضيف مركبات جديدة كل أسبوع — عد قريباً أو أعد ضبط عوامل التصفية.' },
  viewDetails: { en: 'View details & submit offer', ar: 'عرض التفاصيل وتقديم عرض' },
  km: { en: 'km', ar: 'كم' },

  // Lot page
  backToCatalogue: { en: 'Back to catalogue', ar: 'العودة إلى الكتالوج' },
  specifications: { en: 'Specifications', ar: 'المواصفات' },
  lotNotFound: { en: 'Lot not found.', ar: 'لم يتم العثور على اللوت.' },
  loadingLot: { en: 'Loading lot…', ar: 'جارٍ تحميل اللوت…' },
  pricingConfidential: { en: 'Pricing is confidential. Submit your best sealed offer — our team reviews all offers and awards after the auction closes.', ar: 'الأسعار سرّية. قدّم أفضل عرض مغلق لديك — يراجع فريقنا جميع العروض ويرسو المزاد بعد إغلاقه.' },
  fleetMaintained: { en: 'Fleet-maintained · verified documentation', ar: 'مُصانة ضمن الأسطول · وثائق موثّقة' },
  description: { en: 'Description', ar: 'الوصف' },
  serviceHistory: { en: 'Service history', ar: 'سجل الصيانة' },
  accidentHistory: { en: 'Accident history', ar: 'سجل الحوادث' },

  // Offer dialog
  submitOffer: { en: 'Submit an Offer', ar: 'قدّم عرضاً' },
  offersClosed: { en: 'Offers closed', ar: 'العروض مغلقة' },
  signInToOffer: { en: 'Sign in to submit an offer', ar: 'سجّل الدخول لتقديم عرض' },
  signInSub: { en: 'Offers are open to registered B2B buyers only. It takes under a minute.', ar: 'العروض متاحة لمشتري الأعمال المسجّلين فقط. يستغرق الأمر أقل من دقيقة.' },
  haveAccount: { en: 'I already have an account', ar: 'لديّ حساب بالفعل' },
  offerSubmitted: { en: 'Offer submitted', ar: 'تم تقديم العرض' },
  thankYou: { en: (name, amt, label) => `Thank you, ${name}. Your offer of AED ${amt} on ${label} has been received. Our team will be in touch before the auction closes.`, ar: (name, amt, label) => `شكراً لك، ${name}. تم استلام عرضك بقيمة ${amt} درهم على ${label}. سيتواصل معك فريقنا قبل إغلاق المزاد.` },
  done: { en: 'Done', ar: 'تم' },
  submitSealed: { en: 'Submit a sealed offer', ar: 'قدّم عرضاً مغلقاً' },
  yourOfferAed: { en: 'Your offer (AED) *', ar: 'عرضك (درهم) *' },
  offerPh: { en: 'e.g. 165000', ar: 'مثال: 165000' },
  messageOptional: { en: 'Message (optional)', ar: 'رسالة (اختياري)' },
  messagePh: { en: 'Payment terms, collection preference…', ar: 'شروط الدفع، تفضيل الاستلام…' },
  sealedNote: { en: 'Offers are sealed — reserve prices are never shown. Our team reviews all offers and awards after the auction closes.', ar: 'العروض مغلقة — لا تُعرض الأسعار المحجوزة أبداً. يراجع فريقنا جميع العروض ويرسو المزاد بعد إغلاقه.' },
  invalidAmount: { en: 'Please enter a valid offer amount in AED.', ar: 'يرجى إدخال قيمة عرض صحيحة بالدرهم.' },
  submitting: { en: 'Submitting…', ar: 'جارٍ الإرسال…' },
  submitOfferBtn: { en: 'Submit offer', ar: 'إرسال العرض' },
  lotWord: { en: 'Lot', ar: 'لوت' },

  // Buyer auth dialog
  registerTitle: { en: 'Register to bid', ar: 'سجّل للمزايدة' },
  signinTitle: { en: 'Sign in', ar: 'تسجيل الدخول' },
  registerSub: { en: 'Create a free B2B buyer account to submit offers on auction lots.', ar: 'أنشئ حساب مشترٍ B2B مجاني لتقديم عروض على لوتات المزاد.' },
  signinSub: { en: 'Welcome back. Sign in to submit your offer.', ar: 'مرحباً بعودتك. سجّل الدخول لتقديم عرضك.' },
  fullName: { en: 'Full name *', ar: 'الاسم الكامل *' },
  company: { en: 'Company / dealership *', ar: 'الشركة / المعرض *' },
  phone: { en: 'Phone *', ar: 'الهاتف *' },
  tradeLicence: { en: 'Trade licence (optional)', ar: 'الرخصة التجارية (اختياري)' },
  emailLabel: { en: 'Email *', ar: 'البريد الإلكتروني *' },
  passwordLabel: { en: 'Password *', ar: 'كلمة المرور *' },
  passwordPhReg: { en: 'Min 8 characters', ar: '8 أحرف على الأقل' },
  createAccount: { en: 'Create account', ar: 'إنشاء حساب' },
  pleaseWait: { en: 'Please wait…', ar: 'يرجى الانتظار…' },
  alreadyRegistered: { en: 'Already registered?', ar: 'مسجّل بالفعل؟' },
  newBuyer: { en: 'New buyer?', ar: 'مشترٍ جديد؟' },
  toggleToSignin: { en: 'Sign in', ar: 'سجّل الدخول' },
  toggleToRegister: { en: 'Register here', ar: 'سجّل هنا' },
  namePh: { en: 'John Smith', ar: 'محمد أحمد' },
  companyPh: { en: 'Gulf Motors LLC', ar: 'غلف موتورز ش.ذ.م.م' },
  phonePh: { en: '+971 50 XXX XXXX', ar: '+971 50 XXX XXXX' },
  emailPh: { en: 'name@company.com', ar: 'name@company.com' },

  // Spec row labels
  spec_lot: { en: 'Lot number', ar: 'رقم اللوت' },
  spec_year: { en: 'Year', ar: 'السنة' },
  spec_make: { en: 'Make', ar: 'الماركة' },
  spec_model: { en: 'Model', ar: 'الموديل' },
  spec_mileage: { en: 'Mileage', ar: 'المسافة المقطوعة' },
  spec_colour: { en: 'Colour', ar: 'اللون' },
  spec_transmission: { en: 'Transmission', ar: 'ناقل الحركة' },
  spec_fuel: { en: 'Fuel', ar: 'الوقود' },
  spec_vin: { en: 'VIN', ar: 'رقم الهيكل' },
  spec_grade: { en: 'Grade', ar: 'الدرجة' },
  spec_source: { en: 'Source', ar: 'المصدر' },
  spec_vat: { en: 'VAT treatment', ar: 'معالجة الضريبة' },
  spec_availability: { en: 'Availability', ar: 'التوفّر' },
};

export function at(lang, key, ...args) {
  const entry = DICT[key];
  if (!entry) return key;
  const val = entry[lang] || entry.en;
  return typeof val === 'function' ? val(...args) : val;
}

// Arabic labels for backend enum keys (source/status/vat come from the API as keys + English labels)
const SOURCE_AR = { 'ex-rental': 'تأجير سابق', 'lease-return': 'إعادة تأجير طويل', 'fleet-disposal': 'بيع أسطول', 'trade-in': 'مقايضة', 'repossession': 'استرداد', 'damaged': 'مركبة متضررة', 'other': 'أخرى' };
const STATUS_AR = { 'in-yard': 'في الساحة', 'under-inspection': 'قيد الفحص', 'documentation-pending': 'بانتظار المستندات', 'ready-for-auction': 'جاهزة للمزاد', 'sold': 'مُباعة', 'released': 'مُفرج عنها', 'unavailable': 'غير متاحة' };
const VAT_AR = { 'vat-inclusive': 'شامل ضريبة القيمة المضافة (٥٪)', 'margin-scheme': 'ضريبة على هامش الربح', 'zero-rated-export': 'معدل صفري / تصدير', 'vat-exempt': 'معفى من الضريبة' };

export const sourceLabel = (lang, key, enLabel) => (lang === 'ar' ? SOURCE_AR[key] || enLabel : enLabel);
export const statusLabel = (lang, key, enLabel) => (lang === 'ar' ? STATUS_AR[key] || enLabel : enLabel);
export const vatLabel = (lang, key, enLabel) => (lang === 'ar' ? VAT_AR[key] || enLabel : enLabel);

// Arabic option maps for the catalog filter selects (public enum sets)
export const SOURCE_OPTIONS_AR = SOURCE_AR;
export const STATUS_OPTIONS_AR = STATUS_AR;
